import classNames from 'classnames'

import './input.style.css'
import './digitinput.style.css'

type Props = {
  value: string
  onChange: (value: string) => void
  placeHolder?: string
  isError?: boolean
  disabled?: boolean
}

export const DigitInput = ({ value, onChange, placeHolder, isError, disabled }: Props) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value.replace(/\D/g, ''))
  }

  const className = classNames('text-field', 'digit-input', {
    'text-field--error': isError,
  })

  return (
    <input
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      className={className}
      value={value}
      placeholder={placeHolder}
      disabled={disabled}
      onChange={handleChange}
    />
  )
}
